
function gnav(btn,dir){ const tr=btn.closest('.gal').querySelector('.gtrack'); tr.scrollBy({left:dir*tr.clientWidth, behavior:'smooth'}); }
function gdot(tr){ const dots=tr.parentElement.querySelectorAll('.gdots i'); if(!dots.length) return; const idx=Math.round(tr.scrollLeft/tr.clientWidth); dots.forEach((d,i)=>d.classList.toggle('on',i===idx)); }
(function(){
  let imgs=[], idx=0;
  const lb=document.getElementById('lb'); if(!lb) return;
  const lbi=document.getElementById('lbimg'), lbc=document.getElementById('lbcount');
  function show(){ lbi.src=imgs[idx]; if(lbc) lbc.textContent=(imgs.length>1)?(idx+1)+' / '+imgs.length:''; }
  function openLb(list,i){ imgs=list; idx=(i<0?0:i); lb.classList.add('open'); show(); }
  function closeLb(){ lb.classList.remove('open'); lbi.src=''; }
  function move(d){ if(imgs.length<2) return; idx=(idx+d+imgs.length)%imgs.length; show(); }
  document.addEventListener('click',function(e){
    const im=e.target.closest('.gslide img');
    if(im){ const tr=im.closest('.gtrack'); const cur=im.currentSrc||im.src;
      const list=tr?[].map.call(tr.querySelectorAll('img'),x=>x.currentSrc||x.src):[cur];
      openLb(list,list.indexOf(cur)); return; }
    if(e.target.classList.contains('lbnav')){ e.stopPropagation(); move(e.target.classList.contains('r')?1:-1); return; }
    if(e.target===lb || e.target.classList.contains('lbx')){ closeLb(); }
  });
  document.addEventListener('keydown',function(e){ if(!lb.classList.contains('open')) return; if(e.key==='Escape')closeLb(); else if(e.key==='ArrowRight')move(1); else if(e.key==='ArrowLeft')move(-1); });
})();
